import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 800,
      "data-sign": "wrapper_inbound_more_info_modal",
      "title": _vm.rowData.title
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "data-sign": "wrapper_inbound_info_list",
      "columns": _vm.columns,
      "data-source": _vm.dataList,
      "is-filter-box": "",
      "row-key": "package_code",
      "pagination": false
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "wrapper_inbound_more_close",
      "id": "wrapper_inbound_more_close",
      "data-sign": "wrapper_inbound_more_close",
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('关闭')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };